module.exports = __webpack_public_path__ + "img/ron_s_3.07580aa1.png";